import Splide from '@splidejs/splide';

export function initSlidersInPage() {
    const sliders = document.querySelectorAll('.pc_sp_perks_slider') as NodeListOf<HTMLElement>;
    sliders.forEach((slider) => {
        const dataPerks = slider.dataset.perks ? JSON.parse(slider.dataset.perks) : [];
        const dataPerPage = dataPerks.perPage ? parseInt(dataPerks.perPage) : 3;
        const dataPerPageMd = dataPerks.perPageMd ? parseInt(dataPerks.perPageMd) : 2;
        const dataPerPageSm = dataPerks.perPageSm ? parseInt(dataPerks.perPageSm) : 1;

        const splide = new (Splide as any)(slider, {
            type: 'loop',
            perPage: dataPerPage,
            perMove: 1,
            gap: '2rem',
            arrows: true,
            padding: {
                right: dataPerks.paddingRight ? dataPerks.paddingRight : '0',
                left: dataPerks.paddingLeft ? dataPerks.paddingLeft : '0',
            },
            autoplay: ((dataPerks.autoplay && dataPerks.autoplay === "true") ? dataPerks.autoplay : false),
            breakpoints: {
                1024: {
                    perPage: dataPerPageMd,
                },
                600: {
                    perPage: dataPerPageSm,
                },
            },
            pagination: false,
        });
        splide.mount();
    });
}